import React, { useMemo } from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

import SidePanel from 'components/application/SidePanel';

import AttachmentDisplay from 'components/attachments/components/AttachmentDisplay';

import { resourceShape } from 'components/helpers/serialisableResources';

const sidePanelStyle = { width: '960px' };

export default function MasterCoshhSdsSidePanel({
  isOpen,
  masterCoshhDocument,
  onClose,
}) {
  const timestamp = useMemo(() => moment().unix(), [masterCoshhDocument?.id]);

  return (
    <SidePanel
      bodyContent={
        <AttachmentDisplay
          attachedUrl={masterCoshhDocument?.attributes.attachedUrl}
          pdfWrapperClassName='tw-h-full'
          recordType='pdf'
          timestamp={timestamp}
        />
      }
      closeCallback={onClose}
      color='tertiary'
      contentContext={masterCoshhDocument?.id}
      displayClose={true}
      isOpen={isOpen}
      scrollHeader={false}
      sidePanelStyle={sidePanelStyle}
    />
  );
}

MasterCoshhSdsSidePanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  masterCoshhDocument: resourceShape('masterCoshhDocument'),
  onClose: PropTypes.func.isRequired,
};
